import productCardErrorImg from '@ui-kit-icons/icons/productCardErrorImg.png';
import productCardErrorImg2x from '@ui-kit-icons/icons/productCardErrorImg@2x.png';
import productCardErrorImg3x from '@ui-kit-icons/icons/productCardErrorImg@3x.png';

import chiefHat from '@ui-kit-icons/icons/chiefHat.png';
import chiefHat2x from '@ui-kit-icons/icons/chiefHat@2x.png';
import chiefHat3x from '@ui-kit-icons/icons/chiefHat@3x.png';

import chiefHatRed from '@ui-kit-icons/icons/chiefHatRed.png';
import chiefHatRed2x from '@ui-kit-icons/icons/chiefHatRed@2x.png';
import chiefHatRed3x from '@ui-kit-icons/icons/chiefHatRed@3x.png';

import info from '@ui-kit-icons/icons/info.png';
import info2x from '@ui-kit-icons/icons/info@2x.png';
import info3x from '@ui-kit-icons/icons/info@3x.png';

import gift from '@ui-kit-icons/icons/gift.png';
import gift2x from '@ui-kit-icons/icons/gift@2x.png';
import gift3x from '@ui-kit-icons/icons/gift@3x.png';

import infoOutlined from '@ui-kit-icons/icons/infoOutlined.png';
import infoOutlined2x from '@ui-kit-icons/icons/infoOutlined@2x.png';
import infoOutlined3x from '@ui-kit-icons/icons/infoOutlined@3x.png';

import giftRed from '@ui-kit-icons/icons/giftRed.png';
import giftRed2x from '@ui-kit-icons/icons/giftRed@2x.png';
import giftRed3x from '@ui-kit-icons/icons/giftRed@3x.png';

import infoRed from '@ui-kit-icons/icons/infoRed.png';
import infoRed2x from '@ui-kit-icons/icons/infoRed@2x.png';
import infoRed3x from '@ui-kit-icons/icons/infoRed@3x.png';

import infoGrey from '@ui-kit-icons/icons/infoGrey.png';
import infoGrey2x from '@ui-kit-icons/icons/infoGrey@2x.png';
import infoGrey3x from '@ui-kit-icons/icons/infoGrey@3x.png';

import personOutlined from '@ui-kit-icons/icons/personOutlined.png';
import personOutlined2x from '@ui-kit-icons/icons/personOutlined@2x.png';
import personOutlined3x from '@ui-kit-icons/icons/personOutlined@3x.png';

import questionCircled from '@ui-kit-icons/icons/questionCircled.png';
import questionCircled2x from '@ui-kit-icons/icons/questionCircled@2x.png';
import questionCircled3x from '@ui-kit-icons/icons/questionCircled@3x.png';

import questionCircledRed from '@ui-kit-icons/icons/questionCircledRed.png';
import questionCircledRed2x from '@ui-kit-icons/icons/questionCircledRed@2x.png';
import questionCircledRed3x from '@ui-kit-icons/icons/questionCircledRed@3x.png';

import questionCircledLightGrey from '@ui-kit-icons/icons/questionCircledLightGrey.png';
import questionCircledLightGrey2x from '@ui-kit-icons/icons/questionCircledLightGrey@2x.png';
import questionCircledLightGrey3x from '@ui-kit-icons/icons/questionCircledLightGrey@3x.png';

import starOutlined from '@ui-kit-icons/icons/starOutlined.png';
import starOutlined2x from '@ui-kit-icons/icons/starOutlined@2x.png';
import starOutlined3x from '@ui-kit-icons/icons/starOutlined@3x.png';

import starOutlinedRed from '@ui-kit-icons/icons/starOutlinedRed.png';
import starOutlinedRed2x from '@ui-kit-icons/icons/starOutlinedRed@2x.png';
import starOutlinedRed3x from '@ui-kit-icons/icons/starOutlinedRed@3x.png';

import starOutlinedLightGrey from '@ui-kit-icons/icons/starOutlinedLightGrey.png';
import starOutlinedLightGrey2x from '@ui-kit-icons/icons/starOutlinedLightGrey@2x.png';
import starOutlinedLightGrey3x from '@ui-kit-icons/icons/starOutlinedLightGrey@3x.png';

import videoCircled from '@ui-kit-icons/icons/videoCircled.png';
import videoCircled2x from '@ui-kit-icons/icons/videoCircled@2x.png';
import videoCircled3x from '@ui-kit-icons/icons/videoCircled@3x.png';

import videoCircledRed from '@ui-kit-icons/icons/videoCircledRed.png';
import videoCircledRed2x from '@ui-kit-icons/icons/videoCircledRed@2x.png';
import videoCircledRed3x from '@ui-kit-icons/icons/videoCircledRed@3x.png';

import radioButtonOn from '@ui-kit-icons/icons/radioButtonOn.png';
import radioButtonOn2x from '@ui-kit-icons/icons/radioButtonOn@2x.png';
import radioButtonOn3x from '@ui-kit-icons/icons/radioButtonOn@3x.png';

import radioButtonOnGreen from '@ui-kit-icons/icons/radioButtonOnGreen.png';
import radioButtonOnGreen2x from '@ui-kit-icons/icons/radioButtonOnGreen@2x.png';
import radioButtonOnGreen3x from '@ui-kit-icons/icons/radioButtonOnGreen@3x.png';

import minusLightGrey from '@ui-kit-icons/icons/minusLightGrey.png';
import minusLightGrey2x from '@ui-kit-icons/icons/minusLightGrey@2x.png';
import minusLightGrey3x from '@ui-kit-icons/icons/minusLightGrey@3x.png';

import plusRed from '@ui-kit-icons/icons/plusRed.png';
import plusRed2x from '@ui-kit-icons/icons/plusRed@2x.png';
import plusRed3x from '@ui-kit-icons/icons/plusRed@3x.png';
import weight from '@ui-kit-icons/icons/weight.png';
import weight2x from '@ui-kit-icons/icons/weight@2x.png';
import weight3x from '@ui-kit-icons/icons/weight@3x.png';

import weightRed from '@ui-kit-icons/icons/weightRed.png';
import weightRed2x from '@ui-kit-icons/icons/weightRed@2x.png';
import weightRed3x from '@ui-kit-icons/icons/weightRed@3x.png';

import heartOutlined from '@ui-kit-icons/icons/heartOutlined.png';
import heartOutlined2x from '@ui-kit-icons/icons/heartOutlined@2x.png';
import heartOutlined3x from '@ui-kit-icons/icons/heartOutlined@3x.png';

import heartFilled from '@ui-kit-icons/icons/heartFilled.png';
import heartFilled2x from '@ui-kit-icons/icons/heartFilled@2x.png';
import heartFilled3x from '@ui-kit-icons/icons/heartFilled@3x.png';

import heartFilledRed from '@ui-kit-icons/icons/heartFilledRed.png';
import heartFilledRed2x from '@ui-kit-icons/icons/heartFilledRed@2x.png';
import heartFilledRed3x from '@ui-kit-icons/icons/heartFilledRed@3x.png';

import shareOutlined from '@ui-kit-icons/icons/shareOutlined.png';
import shareOutlined2x from '@ui-kit-icons/icons/shareOutlined@2x.png';
import shareOutlined3x from '@ui-kit-icons/icons/shareOutlined@3x.png';

import homeOutlined from '@ui-kit-icons/icons/homeOutlined.png';
import homeOutlined2x from '@ui-kit-icons/icons/homeOutlined@2x.png';
import homeOutlined3x from '@ui-kit-icons/icons/homeOutlined@3x.png';

import pinOutlined from '@ui-kit-icons/icons/pinOutlined.png';
import pinOutlined2x from '@ui-kit-icons/icons/pinOutlined@2x.png';
import pinOutlined3x from '@ui-kit-icons/icons/pinOutlined@3x.png';

import checkmarkOutlinedGreen from '@ui-kit-icons/icons/checkmarkOutlinedGreen.png';
import checkmarkOutlinedGreen2x from '@ui-kit-icons/icons/checkmarkOutlinedGreen@2x.png';
import checkmarkOutlinedGreen3x from '@ui-kit-icons/icons/checkmarkOutlinedGreen@3x.png';

import creditCardIncomeOutlined from '@ui-kit-icons/icons/creditCardIncomeOutlined.png';
import creditCardIncomeOutlined2x from '@ui-kit-icons/icons/creditCardIncomeOutlined@2x.png';
import creditCardIncomeOutlined3x from '@ui-kit-icons/icons/creditCardIncomeOutlined@3x.png';

import creditCardOutcomeOutlinedRed from '@ui-kit-icons/icons/creditCardOutcomeOutlinedRed.png';
import creditCardOutcomeOutlinedRed2x from '@ui-kit-icons/icons/creditCardOutcomeOutlinedRed@2x.png';
import creditCardOutcomeOutlinedRed3x from '@ui-kit-icons/icons/creditCardOutcomeOutlinedRed@3x.png';

import creditCardOutcomeOutlinedGrey from '@ui-kit-icons/icons/creditCardOutcomeOutlinedGrey.png';
import creditCardOutcomeOutlinedGrey2x from '@ui-kit-icons/icons/creditCardOutcomeOutlinedGrey@2x.png';
import creditCardOutcomeOutlinedGrey3x from '@ui-kit-icons/icons/creditCardOutcomeOutlinedGrey@3x.png';

import carOutlined from '@ui-kit-icons/icons/carOutlined.png';
import carOutlined2x from '@ui-kit-icons/icons/carOutlined@2x.png';
import carOutlined3x from '@ui-kit-icons/icons/carOutlined@3x.png';

import cartOutlined from '@ui-kit-icons/icons/cartOutlined.png';
import cartOutlined2x from '@ui-kit-icons/icons/cartOutlined@2x.png';
import cartOutlined3x from '@ui-kit-icons/icons/cartOutlined@3x.png';
import shareFilled from '@ui-kit-icons/icons/shareFilled.png';
import shareFilled2x from '@ui-kit-icons/icons/shareFilled@2x.png';
import shareFilled3x from '@ui-kit-icons/icons/shareFilled@3x.png';

import shareFilledRed from '@ui-kit-icons/icons/shareFilledRed.png';
import shareFilledRed2x from '@ui-kit-icons/icons/shareFilledRed@2x.png';
import shareFilledRed3x from '@ui-kit-icons/icons/shareFilledRed@3x.png';

import thumbsUpOutlinedGrey from '@ui-kit-icons/icons/thumbsUpOutlinedGrey.png';
import thumbsUpOutlinedGrey2x from '@ui-kit-icons/icons/thumbsUpOutlinedGrey@2x.png';
import thumbsUpOutlinedGrey3x from '@ui-kit-icons/icons/thumbsUpOutlinedGrey@3x.png';

import thumbsUpOutlinedGreen from '@ui-kit-icons/icons/thumbsUpOutlinedGreen.png';
import thumbsUpOutlinedGreen2x from '@ui-kit-icons/icons/thumbsUpOutlinedGreen@2x.png';
import thumbsUpOutlinedGreen3x from '@ui-kit-icons/icons/thumbsUpOutlinedGreen@3x.png';

import thumbsDownOutlinedGrey from '@ui-kit-icons/icons/thumbsDownOutlinedGrey.png';
import thumbsDownOutlinedGrey2x from '@ui-kit-icons/icons/thumbsDownOutlinedGrey@2x.png';
import thumbsDownOutlinedGrey3x from '@ui-kit-icons/icons/thumbsDownOutlinedGrey@3x.png';

import thumbsDownOutlinedRed from '@ui-kit-icons/icons/thumbsDownOutlinedRed.png';
import thumbsDownOutlinedRed2x from '@ui-kit-icons/icons/thumbsDownOutlinedRed@2x.png';
import thumbsDownOutlinedRed3x from '@ui-kit-icons/icons/thumbsDownOutlinedRed@3x.png';

import bellOutlined from '@ui-kit-icons/icons/bellOutlined.png';
import bellOutlined2x from '@ui-kit-icons/icons/bellOutlined@2x.png';
import bellOutlined3x from '@ui-kit-icons/icons/bellOutlined@3x.png';

import bellFilled from '@ui-kit-icons/icons/bellFilled.png';
import bellFilled2x from '@ui-kit-icons/icons/bellFilled@2x.png';
import bellFilled3x from '@ui-kit-icons/icons/bellFilled@3x.png';

import bellFilledRed from '@ui-kit-icons/icons/bellFilledRed.png';
import bellFilledRed2x from '@ui-kit-icons/icons/bellFilledRed@2x.png';
import bellFilledRed3x from '@ui-kit-icons/icons/bellFilledRed@3x.png';

import trashOutlinedGrey from '@ui-kit-icons/icons/trashOutlinedGrey.png';
import trashOutlinedGrey2x from '@ui-kit-icons/icons/trashOutlinedGrey@2x.png';
import trashOutlinedGrey3x from '@ui-kit-icons/icons/trashOutlinedGrey@3x.png';

import editOutlinedGrey from '@ui-kit-icons/icons/editOutlinedGrey.png';
import editOutlinedGrey2x from '@ui-kit-icons/icons/editOutlinedGrey@2x.png';
import editOutlinedGrey3x from '@ui-kit-icons/icons/editOutlinedGrey@3x.png';

import clockOutlinedRed from '@ui-kit-icons/icons/clockOutlinedRed.png';
import clockOutlinedRed2x from '@ui-kit-icons/icons/clockOutlinedRed@2x.png';
import clockOutlinedRed3x from '@ui-kit-icons/icons/clockOutlinedRed@3x.png';
import archiveOutlined from '@ui-kit-icons/icons/archiveOutlined.png';
import archiveOutlined2x from '@ui-kit-icons/icons/archiveOutlined@2x.png';
import archiveOutlined3x from '@ui-kit-icons/icons/archiveOutlined@3x.png';

import archiveOutlinedRed from '@ui-kit-icons/icons/archiveOutlinedRed.png';
import archiveOutlinedRed2x from '@ui-kit-icons/icons/archiveOutlinedRed@2x.png';
import archiveOutlinedRed3x from '@ui-kit-icons/icons/archiveOutlinedRed@3x.png';

import checkSquareOutlined from '@ui-kit-icons/icons/checkSquareOutlined.png';
import checkSquareOutlined2x from '@ui-kit-icons/icons/checkSquareOutlined@2x.png';
import checkSquareOutlined3x from '@ui-kit-icons/icons/checkSquareOutlined@3x.png';

import checkSquareOutlinedRed from '@ui-kit-icons/icons/checkSquareOutlinedRed.png';
import checkSquareOutlinedRed2x from '@ui-kit-icons/icons/checkSquareOutlinedRed@2x.png';
import checkSquareOutlinedRed3x from '@ui-kit-icons/icons/checkSquareOutlinedRed@3x.png';

import clockFilledWhite from '@ui-kit-icons/icons/clockFilledWhite.png';
import clockFilledWhite2x from '@ui-kit-icons/icons/clockFilledWhite@2x.png';
import clockFilledWhite3x from '@ui-kit-icons/icons/clockFilledWhite@3x.png';

import awardFilledGrey from '@ui-kit-icons/icons/awardFilledGrey.png';
import awardFilledGrey2x from '@ui-kit-icons/icons/awardFilledGrey@2x.png';
import awardFilledGrey3x from '@ui-kit-icons/icons/awardFilledGrey@3x.png';

import checkmarkFilledCircleWhite from '@ui-kit-icons/icons/checkmarkFilledCircleWhite.png';
import checkmarkFilledCircleWhite2x from '@ui-kit-icons/icons/checkmarkFilledCircleWhite@2x.png';
import checkmarkFilledCircleWhite3x from '@ui-kit-icons/icons/checkmarkFilledCircleWhite@3x.png';

import bookmarkOutlined from '@ui-kit-icons/icons/bookmarkOutlined.png';
import bookmarkOutlined2x from '@ui-kit-icons/icons/bookmarkOutlined@2x.png';
import bookmarkOutlined3x from '@ui-kit-icons/icons/bookmarkOutlined@3x.png';

import bookmarkOutlinedRed from '@ui-kit-icons/icons/bookmarkOutlinedRed.png';
import bookmarkOutlinedRed2x from '@ui-kit-icons/icons/bookmarkOutlinedRed@2x.png';
import bookmarkOutlinedRed3x from '@ui-kit-icons/icons/bookmarkOutlinedRed@3x.png';

import calendarFilledDarkGrey from '@ui-kit-icons/icons/calendarFilledDarkGrey.png';
import calendarFilledDarkGrey2x from '@ui-kit-icons/icons/calendarFilledDarkGrey@2x.png';
import calendarFilledDarkGrey3x from '@ui-kit-icons/icons/calendarFilledDarkGrey@3x.png';

import cartFilledDarkGrey from '@ui-kit-icons/icons/cartFilledDarkGrey.png';
import cartFilledDarkGrey2x from '@ui-kit-icons/icons/cartFilledDarkGrey@2x.png';
import cartFilledDarkGrey3x from '@ui-kit-icons/icons/cartFilledDarkGrey@3x.png';

import personDoneFilledDarkGrey from '@ui-kit-icons/icons/personDoneFilledDarkGrey.png';
import personDoneFilledDarkGrey2x from '@ui-kit-icons/icons/personDoneFilledDarkGrey@2x.png';
import personDoneFilledDarkGrey3x from '@ui-kit-icons/icons/personDoneFilledDarkGrey@3x.png';

import personDoneOutlinedLightGrey from '@ui-kit-icons/icons/personDoneOutlinedLightGrey.png';
import personDoneOutlinedLightGrey2x from '@ui-kit-icons/icons/personDoneOutlinedLightGrey@2x.png';
import personDoneOutlinedLightGrey3x from '@ui-kit-icons/icons/personDoneOutlinedLightGrey@3x.png';

import personDoneOutlinedRed from '@ui-kit-icons/icons/personDoneOutlinedRed.png';
import personDoneOutlinedRed2x from '@ui-kit-icons/icons/personDoneOutlinedRed@2x.png';
import personDoneOutlinedRed3x from '@ui-kit-icons/icons/personDoneOutlinedRed@3x.png';

import shoppingbagFilledDarkGrey from '@ui-kit-icons/icons/shoppingbagFilledDarkGrey.png';
import shoppingbagFilledDarkGrey2x from '@ui-kit-icons/icons/shoppingbagFilledDarkGrey@2x.png';
import shoppingbagFilledDarkGrey3x from '@ui-kit-icons/icons/shoppingbagFilledDarkGrey@3x.png';

import bookmarkFilledRed from '@ui-kit-icons/icons/bookmarkFilledRed.png';
import bookmarkFilledRed2x from '@ui-kit-icons/icons/bookmarkFilledRed@2x.png';
import bookmarkFilledRed3x from '@ui-kit-icons/icons/bookmarkFilledRed@3x.png';

import chevronLeftRed from '@ui-kit-icons/icons/chevronLeftRed.png';
import chevronLeftRed2x from '@ui-kit-icons/icons/chevronLeftRed@2x.png';
import chevronLeftRed3x from '@ui-kit-icons/icons/chevronLeftRed@3x.png';

import chevronLeftLightGrey from '@ui-kit-icons/icons/chevronLeftLightGrey.png';
import chevronLeftLightGrey2x from '@ui-kit-icons/icons/chevronLeftLightGrey@2x.png';
import chevronLeftLightGrey3x from '@ui-kit-icons/icons/chevronLeftLightGrey@3x.png';

import refreshOutlinedGrey from '@ui-kit-icons/icons/refreshOutlinedGrey.png';
import refreshOutlinedGrey2x from '@ui-kit-icons/icons/refreshOutlinedGrey@2x.png';
import refreshOutlinedGrey3x from '@ui-kit-icons/icons/refreshOutlinedGrey@3x.png';

import starOutlinedGrey from '@ui-kit-icons/icons/starOutlinedGrey.png';
import starOutlinedGrey2x from '@ui-kit-icons/icons/starOutlinedGrey@2x.png';
import starOutlinedGrey3x from '@ui-kit-icons/icons/starOutlinedGrey@3x.png';

import chevronDown from '@ui-kit-icons/icons/chevronDown.png';
import chevronDown2x from '@ui-kit-icons/icons/chevronDown@2x.png';
import chevronDown3x from '@ui-kit-icons/icons/chevronDown@3x.png';

import minus from '@ui-kit-icons/icons/minus.png';
import minus2x from '@ui-kit-icons/icons/minus@2x.png';
import minus3x from '@ui-kit-icons/icons/minus@3x.png';

import minusHovered from '@ui-kit-icons/icons/minusHovered.png';
import minusHovered2x from '@ui-kit-icons/icons/minusHovered@2x.png';
import minusHovered3x from '@ui-kit-icons/icons/minusHovered@3x.png';
import plus from '@ui-kit-icons/icons/plus.png';
import plus2x from '@ui-kit-icons/icons/plus@2x.png';
import plus3x from '@ui-kit-icons/icons/plus@3x.png';

import plusHovered from '@ui-kit-icons/icons/plusHovered.png';
import plusHovered2x from '@ui-kit-icons/icons/plusHovered@2x.png';
import plusHovered3x from '@ui-kit-icons/icons/plusHovered@3x.png';

import trashOutlinedRed from '@ui-kit-icons/icons/trashOutlinedRed.png';
import trashOutlinedRed2x from '@ui-kit-icons/icons/trashOutlinedRed@2x.png';
import trashOutlinedRed3x from '@ui-kit-icons/icons/trashOutlinedRed@3x.png';

import rubleOutlinedGreen from '@ui-kit-icons/icons/rubleOutlinedGreen.png';
import rubleOutlinedGreen2x from '@ui-kit-icons/icons/rubleOutlinedGreen@2x.png';
import rubleOutlinedGreen3x from '@ui-kit-icons/icons/rubleOutlinedGreen@3x.png';

import crossLighGrey from '@ui-kit-icons/icons/crossLighGrey.png';
import crossLighGrey2x from '@ui-kit-icons/icons/crossLighGrey@2x.png';
import crossLighGrey3x from '@ui-kit-icons/icons/crossLighGrey@3x.png';

let iconsList = {
  // crossLighGrey
  crossLighGrey: {
    x1: crossLighGrey,
    x2: crossLighGrey2x,
    x3: crossLighGrey3x
  },
  // ruble
  rubleOutlinedGreen: {
    x1: rubleOutlinedGreen,
    x2: rubleOutlinedGreen2x,
    x3: rubleOutlinedGreen3x
  },
  // trash
  trashOutlinedGrey: {
    x1: trashOutlinedGrey,
    x2: trashOutlinedGrey2x,
    x3: trashOutlinedGrey3x
  },
  trashOutlinedRed: {
    x1: trashOutlinedRed,
    x2: trashOutlinedRed2x,
    x3: trashOutlinedRed3x
  },
  // thumbs-down
  thumbsDownOutlinedGrey: {
    x1: thumbsDownOutlinedGrey,
    x2: thumbsDownOutlinedGrey2x,
    x3: thumbsDownOutlinedGrey3x
  },
  thumbsDownOutlinedRed: {
    x1: thumbsDownOutlinedRed,
    x2: thumbsDownOutlinedRed2x,
    x3: thumbsDownOutlinedRed3x
  },
  // thumbs-up
  thumbsUpOutlinedGrey: {
    x1: thumbsUpOutlinedGrey,
    x2: thumbsUpOutlinedGrey2x,
    x3: thumbsUpOutlinedGrey3x
  },
  thumbsUpOutlinedGreen: {
    x1: thumbsUpOutlinedGreen,
    x2: thumbsUpOutlinedGreen2x,
    x3: thumbsUpOutlinedGreen3x
  },
  // gift
  gift: {
    x1: gift,
    x2: gift2x,
    x3: gift3x
  },
  giftRed: {
    x1: giftRed,
    x2: giftRed2x,
    x3: giftRed3x
  },
  // minus
  minus: {
    x1: minus,
    x2: minus2x,
    x3: minus3x
  },
  minusHovered: {
    x1: minusHovered,
    x2: minusHovered2x,
    x3: minusHovered3x
  },
  minusLightGrey: {
    x1: minusLightGrey,
    x2: minusLightGrey2x,
    x3: minusLightGrey3x
  },
  // plus
  plus: {
    x1: plus,
    x2: plus2x,
    x3: plus3x
  },
  plusRed: {
    x1: plusRed,
    x2: plusRed2x,
    x3: plusRed3x
  },
  plusHovered: {
    x1: plusHovered,
    x2: plusHovered2x,
    x3: plusHovered3x
  },
  // chevron
  chevronDown: {
    x1: chevronDown,
    x2: chevronDown2x,
    x3: chevronDown3x
  },
  // Заглушка продуктовой карточки если ошибка
  productCardErrorImg: {
    x1: productCardErrorImg,
    x2: productCardErrorImg2x,
    x3: productCardErrorImg3x
  },
  // radio-button-on
  radioButtonOn: {
    x1: radioButtonOn,
    x2: radioButtonOn2x,
    x3: radioButtonOn3x
  },
  radioButtonOnGreen: {
    x1: radioButtonOnGreen,
    x2: radioButtonOnGreen2x,
    x3: radioButtonOnGreen3x
  },
  // chevron-left стрелка без палки влево
  chevronLeftRed: {
    x1: chevronLeftRed,
    x2: chevronLeftRed2x,
    x3: chevronLeftRed3x
  },
  chevronLeftLightGrey: {
    x1: chevronLeftLightGrey,
    x2: chevronLeftLightGrey2x,
    x3: chevronLeftLightGrey3x
  },
  // refresh
  refreshOutlinedGrey: {
    x1: refreshOutlinedGrey,
    x2: refreshOutlinedGrey2x,
    x3: refreshOutlinedGrey3x
  },
  // star
  starOutlinedGrey: {
    x1: starOutlinedGrey,
    x2: starOutlinedGrey2x,
    x3: starOutlinedGrey3x
  },
  // bookmark
  bookmarkOutlined: {
    x1: bookmarkOutlined,
    x2: bookmarkOutlined2x,
    x3: bookmarkOutlined3x
  },
  bookmarkOutlinedRed: {
    x1: bookmarkOutlinedRed,
    x2: bookmarkOutlinedRed2x,
    x3: bookmarkOutlinedRed3x
  },
  bookmarkFilledRed: {
    x1: bookmarkFilledRed,
    x2: bookmarkFilledRed2x,
    x3: bookmarkFilledRed3x
  },
  // checkmark
  checkSquareOutlined: {
    x1: checkSquareOutlined,
    x2: checkSquareOutlined2x,
    x3: checkSquareOutlined3x
  },
  checkSquareOutlinedRed: {
    x1: checkSquareOutlinedRed,
    x2: checkSquareOutlinedRed2x,
    x3: checkSquareOutlinedRed3x
  },
  checkmarkFilledCircleWhite: {
    x1: checkmarkFilledCircleWhite,
    x2: checkmarkFilledCircleWhite2x,
    x3: checkmarkFilledCircleWhite3x
  },
  // clock
  clockFilledWhite: {
    x1: clockFilledWhite,
    x2: clockFilledWhite2x,
    x3: clockFilledWhite3x
  },
  // person-done
  personDoneFilledDarkGrey: {
    x1: personDoneFilledDarkGrey,
    x2: personDoneFilledDarkGrey2x,
    x3: personDoneFilledDarkGrey3x
  },
  personDoneOutlinedLightGrey: {
    x1: personDoneOutlinedLightGrey,
    x2: personDoneOutlinedLightGrey2x,
    x3: personDoneOutlinedLightGrey3x
  },
  personDoneOutlinedRed: {
    x1: personDoneOutlinedRed,
    x2: personDoneOutlinedRed2x,
    x3: personDoneOutlinedRed3x
  },

  // shopping-bag
  shoppingbagFilledDarkGrey: {
    x1: shoppingbagFilledDarkGrey,
    x2: shoppingbagFilledDarkGrey2x,
    x3: shoppingbagFilledDarkGrey3x
  },
  // award
  awardFilledGrey: {
    x1: awardFilledGrey,
    x2: awardFilledGrey2x,
    x3: awardFilledGrey3x
  },
  // cart
  cartFilledDarkGrey: {
    x1: cartFilledDarkGrey,
    x2: cartFilledDarkGrey2x,
    x3: cartFilledDarkGrey3x
  },
  // calendar
  calendarFilledDarkGrey: {
    x1: calendarFilledDarkGrey,
    x2: calendarFilledDarkGrey2x,
    x3: calendarFilledDarkGrey3x
  },
  checkmarkOutlinedGreen: {
    x1: checkmarkOutlinedGreen,
    x2: checkmarkOutlinedGreen2x,
    x3: checkmarkOutlinedGreen3x
  },
  // archive - архив
  archiveOutlined: {
    x1: archiveOutlined,
    x2: archiveOutlined2x,
    x3: archiveOutlined3x
  },
  archiveOutlinedRed: {
    x1: archiveOutlinedRed,
    x2: archiveOutlinedRed2x,
    x3: archiveOutlinedRed3x
  },
  // шляпа повара chief
  chiefHat: {
    x1: chiefHat,
    x2: chiefHat2x,
    x3: chiefHat3x
  },
  chiefHatRed: {
    x1: chiefHatRed,
    x2: chiefHatRed2x,
    x3: chiefHatRed3x
  },
  // инфо info
  infoOutlined: {
    x1: infoOutlined,
    x2: infoOutlined2x,
    x3: infoOutlined3x
  },
  // инфо
  info: {
    x1: info,
    x2: info2x,
    x3: info3x
  },
  infoRed: {
    x1: infoRed,
    x2: infoRed2x,
    x3: infoRed3x
  },
  infoGrey: {
    x1: infoGrey,
    x2: infoGrey2x,
    x3: infoGrey3x
  },
  // person
  personOutlined: {
    x1: personOutlined,
    x2: personOutlined2x,
    x3: personOutlined3x
  },
  // знак вопроса question
  questionCircled: {
    x1: questionCircled,
    x2: questionCircled2x,
    x3: questionCircled3x
  },
  questionCircledRed: {
    x1: questionCircledRed,
    x2: questionCircledRed2x,
    x3: questionCircledRed3x
  },
  questionCircledLightGrey: {
    x1: questionCircledLightGrey,
    x2: questionCircledLightGrey2x,
    x3: questionCircledLightGrey3x
  },
  // звезда
  starOutlined: {
    x1: starOutlined,
    x2: starOutlined2x,
    x3: starOutlined3x
  },
  starOutlinedRed: {
    x1: starOutlinedRed,
    x2: starOutlinedRed2x,
    x3: starOutlinedRed3x
  },
  starOutlinedLightGrey: {
    x1: starOutlinedLightGrey,
    x2: starOutlinedLightGrey2x,
    x3: starOutlinedLightGrey3x
  },
  // видео
  videoCircled: {
    x1: videoCircled,
    x2: videoCircled2x,
    x3: videoCircled3x
  },
  videoCircledRed: {
    x1: videoCircledRed,
    x2: videoCircledRed2x,
    x3: videoCircledRed3x
  },
  // весы weight
  weight: {
    x1: weight,
    x2: weight2x,
    x3: weight3x
  },
  weightRed: {
    x1: weightRed,
    x2: weightRed2x,
    x3: weightRed3x
  },
  // home
  homeOutlined: {
    x1: homeOutlined,
    x2: homeOutlined2x,
    x3: homeOutlined3x
  },
  // pin
  pinOutlined: {
    x1: pinOutlined,
    x2: pinOutlined2x,
    x3: pinOutlined3x
  },
  // сердечко лайк heart like
  heartOutlined: {
    x1: heartOutlined,
    x2: heartOutlined2x,
    x3: heartOutlined3x
  },
  heartFilled: {
    x1: heartFilled,
    x2: heartFilled2x,
    x3: heartFilled3x
  },
  heartFilledRed: {
    x1: heartFilledRed,
    x2: heartFilledRed2x,
    x3: heartFilledRed3x
  },
  // share
  shareOutlined: {
    x1: shareOutlined,
    x2: shareOutlined2x,
    x3: shareOutlined3x
  },
  shareFilled: {
    x1: shareFilled,
    x2: shareFilled2x,
    x3: shareFilled3x
  },
  shareFilledRed: {
    x1: shareFilledRed,
    x2: shareFilledRed2x,
    x3: shareFilledRed3x
  },
  // creditcard-income
  creditCardIncomeOutlined: {
    x1: creditCardIncomeOutlined,
    x2: creditCardIncomeOutlined2x,
    x3: creditCardIncomeOutlined3x
  },
  // creditcard-outcome
  creditCardOutcomeOutlinedRed: {
    x1: creditCardOutcomeOutlinedRed,
    x2: creditCardOutcomeOutlinedRed2x,
    x3: creditCardOutcomeOutlinedRed3x
  },
  creditCardOutcomeOutlinedGrey: {
    x1: creditCardOutcomeOutlinedGrey,
    x2: creditCardOutcomeOutlinedGrey2x,
    x3: creditCardOutcomeOutlinedGrey3x
  },
  // car
  carOutlined: {
    x1: carOutlined,
    x2: carOutlined2x,
    x3: carOutlined3x
  },
  // cart
  cartOutlined: {
    x1: cartOutlined,
    x2: cartOutlined2x,
    x3: cartOutlined3x
  },
  // колокол bell
  bellOutlined: {
    x1: bellOutlined,
    x2: bellOutlined2x,
    x3: bellOutlined3x
  },
  bellFilled: {
    x1: bellFilled,
    x2: bellFilled2x,
    x3: bellFilled3x
  },
  bellFilledRed: {
    x1: bellFilledRed,
    x2: bellFilledRed2x,
    x3: bellFilledRed3x
  },
  // edit
  editOutlinedGrey: {
    x1: editOutlinedGrey,
    x2: editOutlinedGrey2x,
    x3: editOutlinedGrey3x
  },
  // clock
  clockOutlinedRed: {
    x1: clockOutlinedRed,
    x2: clockOutlinedRed2x,
    x3: clockOutlinedRed3x
  }
};

export default iconsList;
